var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',[_c('section-component',{attrs:{"form":_vm.form,"gridId":_vm.gridId,"rowData":_vm.rowData}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }